import React, { useState } from "react";
import { Nav, NavItem, TabContent, TabPane, Container } from "reactstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import CloseMatch from "./components/CloseMatch";
import Encounters from "./components/Encounters";
import FaxDetails from "./components/FaxDetails";
import HistoricalClaims from "./components/HistoricalClaims";
import RefferralFile from "./components/RefferralFile";
import ErrorBoundary from "components/ErrorBoundary";
import { useEffect } from "react";
import { ModuleAccess } from "utils/moduleaccess";

const ClaimsDetailTab = (props) => {
  // const { module } = props;
  // const [activeTab, setActiveTab] = useState('1');

  // const hasPermission = (code) => {
  //   return ModuleAccess("CLM", code);
  //   //return (module && module.actions.indexOf(code) != -1)
  // }

 

  // useEffect(() => {
  //   if (hasPermission("HC")) {
  //     setKey("HistoricalClaims");
  //   }
  //   else if (hasPermission("CSM")) {
  //     setKey("CloseMatch");
  //   }
  //   else if (hasPermission("FAX")) {
  //     setKey("FaxDetails");
  //   }
  //   else if (hasPermission("ENC")) {
  //     setKey("Encounters");
  //   }
  //   else if (hasPermission("REF")) {
  //     setKey("Referrals");
  //   }
  // }, []);

  // const hasHistoricalClaims = activeTab === '1';
  // const hasCloseMatch = activeTab === '2';
  // const hasFixDetails = activeTab === '3';
  // const hasEncounters = activeTab === '4';
  // const hasReferral = activeTab === '5';

  const { module, orgId, tenantID, patientId, coveredEntity
  } = props;
  const [key, setKey] = useState("HistoricalClaims");
  const [reset, setReset] = useState(false);
  const toggle = (tab) => {
    if (key !== tab) {
      setKey(tab);
    }
  };
  const onKeyChange = (k) => {
    setKey(k);
    setReset(!reset);
    if (k == "HistoricalClaims") {
      toggle("HistoricalClaims")
    }
    if (k == "CloseMatch") {
      toggle("CloseMatch")
    }
    if (k == "FaxDetails") {
      toggle("FaxDetails")
    }
    if (k == "Encounters") {
      toggle("Encounters")
    }
    if (k == "Referrals") {
      toggle("Referrals")
    }
  };

  return (
    <div>
      <Container fluid className="my-0 bin_info">
        {/* <Nav tabs className='py-0'>
        <NavItem hidden={!hasPermission("HC")}>
          <NavLink
            to=""
            className={classNames({
              activeState: activeTab === '1',
            })}
            onClick={() => {
              toggle('1');
            }}
          >
            Historical Claims
          </NavLink>
        </NavItem>
        <NavItem hidden={!hasPermission("CSM")}>
          <NavLink
            to=""
            className={classNames({
              activeState: activeTab === '2',
            })}
            onClick={() => {
              toggle('2');
            }}
          >
            Close Match
          </NavLink>
        </NavItem>

        <NavItem hidden={!hasPermission("FAX")}>
          <NavLink
            to=""
            className={classNames({
              activeState: activeTab === '3',
            })}
            onClick={() => {
              toggle('3');
            }}
          >
            Fax Details
          </NavLink>
        </NavItem>
        <NavItem hidden={!hasPermission("ENC")}>
          <NavLink
            to=""
            className={classNames({
              activeState: activeTab === '4',
            })}
            onClick={() => {
              toggle('4');
            }}
          >
            Encounters
          </NavLink>
        </NavItem>
        <NavItem hidden={!hasPermission("REF")}>
          <NavLink
            to=""
            className={classNames({
              activeState: activeTab === '5',
            })}
            onClick={() => {
              toggle('5');
            }}
          >
            Referrals
          </NavLink>
        </NavItem>
      </Nav> */}

        <Tabs
          id="controlled-tab-example"
          className="m-0"
          activeKey={key}
          onSelect={(k) => onKeyChange(k)}
        >
          <Tab eventKey="HistoricalClaims" title="Historical Claims">
            <ErrorBoundary>
              <HistoricalClaims
                module={module}
                orgId={orgId}
                reset={reset}
                tenantID={tenantID}
                patientId={patientId}
                coveredEntity={coveredEntity}


                {...props}
              />
            </ErrorBoundary>
          </Tab>
          <Tab eventKey="CloseMatch" title="Close Match">
            <ErrorBoundary>
              <CloseMatch
                module={module}
                orgId={orgId}
                reset={reset}
                patientId={patientId}
                tenantID={tenantID}
                coveredEntity={coveredEntity}



                {...props}
              />
            </ErrorBoundary>
          </Tab>
          <Tab eventKey="FaxDetails" title="Fax Details">
            <ErrorBoundary>
              <FaxDetails
                module={module}
                orgId={orgId}
                reset={reset}
                {...props}
                tenantID={tenantID}
                patientId={patientId}
                coveredEntityID={coveredEntity}

              />
            </ErrorBoundary>
          </Tab>
          <Tab eventKey="Encounters" title="Encounters">
            <ErrorBoundary>
              <Encounters
                module={module}
                orgId={orgId}
                reset={reset}
                patientId={patientId}
                tenantID={tenantID}
                coveredEntity={coveredEntity}

                {...props}
              />
            </ErrorBoundary>
          </Tab>
          <Tab eventKey="Referrals" title="Referrals">
            <ErrorBoundary>
              <RefferralFile
                module={module}
                orgId={orgId}
                reset={reset}
                patientId={patientId}
                tenantID={tenantID}
                coveredEntity={coveredEntity}

                {...props}
              />
            </ErrorBoundary>
          </Tab>
        </Tabs>
      </Container>

      {/* <TabContent activeTab={activeTab} className='px-3 mt-0 pt-0'>
        <TabPane tabId='1' hidden={!hasPermission("HC")} >
          {hasHistoricalClaims && (
            <ErrorBoundary>
              <HistoricalClaims {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='2' hidden={!hasPermission("CSM")}>
          {hasCloseMatch && (
            <ErrorBoundary>
              <CloseMatch {...props} />
            </ErrorBoundary>
          )}
        </TabPane>

        <TabPane tabId='3' hidden={!hasPermission("FAX")}>
          {hasFixDetails && (
            <ErrorBoundary>
              <FaxDetails providerIds={props.providerIds} {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='4' hidden={!hasPermission("ENC")}>
          {hasEncounters && (
            <ErrorBoundary>
              <Encounters {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='5' hidden={!hasPermission("REF")}>
          {hasReferral && (
            <ErrorBoundary>
              <RefferralFile {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent> */}
    </div>
  );
};

export default ClaimsDetailTab;
